function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="16" height="16" viewBox="0 0 16 16" {...props}><path d="M12 4L8 8m0 0l-4 4m4-4L4 4m4 4l4 4" stroke="#36C" strokeLinecap="round" strokeLinejoin="round" /></svg>;
});